/**
 * Detect the closest aspect-ratio key for an image's natural dimensions.
 *
 * @param {number} width  - image natural width in pixels
 * @param {number} height - image natural height in pixels
 * @returns {'1:1'|'4:3'|'3:4'|'16:9'|'9:16'} closest matching ratio key
 */
export function detectAspectRatio(width, height) {
  const ratio = width / height
  const RATIOS = [
    { key: '1:1', value: 1 },
    { key: '4:3', value: 4 / 3 },
    { key: '3:4', value: 3 / 4 },
    { key: '16:9', value: 16 / 9 },
    { key: '9:16', value: 9 / 16 },
  ]
  let closest = RATIOS[0]
  let minDiff = Math.abs(ratio - RATIOS[0].value)
  for (const r of RATIOS) {
    const diff = Math.abs(ratio - r.value)
    if (diff < minDiff) {
      minDiff = diff
      closest = r
    }
  }
  return closest.key
}
